import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import indexRoutes from "routes/index.jsx";
import "assets/scss/material-kit-react.css?v=1.2.0";

/* Redux */
import {createStore, applyMiddleware} from 'redux';
import rootReducer from './store/reducers';
import { fetchAllPosts } from './store/actions';
import { Provider } from 'react-redux'
import thunk from "redux-thunk";

//const store = createStore(rootReducer);
const store = createStore(rootReducer, applyMiddleware(thunk));

store.dispatch(fetchAllPosts());

var hist = createBrowserHistory();

ReactDOM.render(
  <Provider store={store}>
    <Router history={hist}>
      <Switch>
        {indexRoutes.map((prop, key) => {
          return <Route path={prop.path} key={key} component={prop.component} />;
        })}
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js